import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getIsShowingProject } from "../reducers/project-state";

const IframeBridgeHOC = function (WrappedComponent) {
    class IframeBridgeComponent extends React.Component {
        constructor(props) {
            super(props);
            this.handleMessage = this.handleMessage.bind(this);
        }
        componentDidMount() {
            window.addEventListener("message", this.handleMessage);
        }
        componentWillUnmount() {
            window.removeEventListener("message", this.handleMessage);
        }
        handleMessage(e) {
            if (e.origin !== location.origin) {
                return;
            }

            if (!this.props.canExportProject || !this.props.vm || !e.source) {
                return;
            }

            const data = e.data;
            if (!data || typeof data !== "object") {
                return;
            }

            if (
                data.type !== "TW_REQUEST_SB3" ||
                typeof data.requestId !== "string"
            ) {
                return;
            }

            this.props.vm
                .saveProjectSb3("arraybuffer")
                .then((buffer) => {
                    e.source.postMessage(
                        {
                            type: "TW_SB3_RESULT",
                            requestId: data.requestId,
                            buffer,
                        },
                        e.origin,
                        [buffer],
                    );
                })
                .catch((err) => {
                    e.source.postMessage(
                        {
                            type: "TW_SB3_ERROR",
                            requestId: data.requestId,
                            message:
                                err && err.message ? err.message : String(err),
                        },
                        e.origin,
                    );
                });
        }
        render() {
            const {
                /* eslint-disable no-unused-vars */
                canExportProject,
                vm,
                /* eslint-enable no-unused-vars */
                ...props
            } = this.props;
            return <WrappedComponent {...props} />;
        }
    }

    IframeBridgeComponent.propTypes = {
        canExportProject: PropTypes.bool,
        vm: PropTypes.shape({
            saveProjectSb3: PropTypes.func,
        }),
    };

    const mapStateToProps = (state) => ({
        canExportProject: getIsShowingProject(
            state.scratchGui.projectState.loadingState,
        ),
        vm: state.scratchGui.vm,
    });

    const mapDispatchToProps = () => ({});

    return connect(mapStateToProps, mapDispatchToProps)(IframeBridgeComponent);
};

export { IframeBridgeHOC as default };
